/**
 * Created by az on 2017/7/26.
 */
import QbSlider from './QbSlider';

export default QbSlider;